(ns pfo.widget.tabs (:require [pfo.util :as util :refer [entity handler]]))

(defn old-tab [aname id active-state tab-contents]
  (let [active (or (nil? active-state) (= id @active-state))]
    [:li.tab-header-and-content {:key (str "tab-" aname)}
     [:span.tab-header [:a.tab-link {:class (if active "is-active" "")
                                     :on-click (handler #(when-not (nil? active-state) (reset! active-state id)))}
                        aname]]
     [:div.tab-content {:class (if active "is-open" "") :style (if active {:display "block"} {})}
      tab-contents]]))

(defn header-tabs [options & tab-items]
  (let [tab-items (remove nil? tab-items)]

    [:div.o-header-tabs.redesign {:style (:style options)} #_{:style {:position "relative" :top "-7em"}}
     [:header.c-header {:style (:header-style options)}
      [:ul (doall
             (map-indexed
               (fn [index tab-item]
                 [:li {:key (str index) :class (if (:inactive tab-item)
                                                 "inactive"
                                                 (if (= @(:active-state tab-item) (:tab-id tab-item)) "active" ""))}
                  [:h2 {:on-click (fn [ev]
                                    (if-let [url (:url tab-item)]
                                      (util/set-location url)
                                      (reset! (:active-state tab-item) (:tab-id tab-item))))} (:header tab-item)]])
               tab-items))]
      [:aside
       (:controls (first (filterv #(= (:tab-id %) @(:active-state %)) tab-items)))]]
     [:main {:key "tab"}
      (:content (first (filterv #(= (:tab-id %) @(:active-state %)) tab-items)))]]))

(defn tabs [& tab-items]
  (let [tab-items (remove nil? tab-items)]
   [:div.o-tabs-and-content.redesign
     [:div.o-tabs-and-content__topbar
      [:ul.o-tabs-and-content__tabs (doall
                                      (for [tab-item tab-items]
                                        [:li.o-tabs-and-content__tab
                                         {:key (:tab-id tab-item)
                                          :class (if (:inactive tab-item)
                                                   "is-inactive"
                                                   (if (= @(:active-state tab-item) (:tab-id tab-item)) "is-active" ""))

                                          :on-click (fn [ev]
                                                      (if-let [url (if-let [url-fn (:url-fn tab-item)] (url-fn) (:url tab-item))]
                                                        (util/set-location url)
                                                        (reset! (:active-state tab-item) (:tab-id tab-item))))} (:header tab-item)]))]
      [:aside.o-tabs-and-content__aside
       (:controls (first (filterv #(= (:tab-id %) @(:active-state %)) tab-items)))]]
     [:main {:key (gensym "tab")}
      (:content (first (filterv #(= (:tab-id %) @(:active-state %)) tab-items)))]]))

(defn tab [aname id active-state tab-contents controls]
  (let [url    (:url id)
        url-fn (:url-fn id)
        tab-id (if (or url url-fn) (:id id) id)]
    (merge
     (when url {:url url})
     (when url-fn {:url-fn url-fn})
     {:header       aname
      :tab-id       tab-id
      :active-state (or active-state (atom nil))
      :content      tab-contents
      :controls     controls})))

(defn tabs-header-and-content [header content]
  [:div.o-tabs-and-content.redesign
   header content])

(defn tabs-header [tab-controls & tab-items]
  (let [tab-items (remove nil? tab-items)]
    [:div.o-tabs-and-content__topbar
     [:ul.o-tabs-and-content__tabs (doall
                                     (for [[index tab-item] (map-indexed vector tab-items)]
                                       ^{:key index} tab-item))]
     [:aside.o-tabs-and-content__aside
      tab-controls]]))

(defn tab-header [{:keys [active-atom
                    tab-id]} tab-header]
  [:li.o-tabs-and-content__tab
   {:key tab-id
    :class (if (= @active-atom tab-id) "is-active" "")

    :on-click (util/handler (fn []
                              (reset! active-atom tab-id)))} tab-header])

(defn inactive-tab [aname id active-state tab-contents controls]
  {:header aname
   :tab-id id
   :active-state (or active-state (atom nil))
   :inactive true
   :content tab-contents
   :controls controls})
